$(document).ready(function() {

// $(".header__icons .customer-links a").mouseover(function(){
//     $(this).parents(".customer-links").addClass("show_box");
//     $(this).parents(".customer-links").find(".customer-account-popup.box-popups").show();
   
//   });

// $(".header__icons .customer-links a").mouseout(function(){
//     $(this).parents(".customer-links").removeClass("show_box");
//     $(this).parents(".customer-links").find(".customer-account-popup.box-popups").hide();
   
//   });


  
  // $(document).on("click",".yv-color-filter li.yv-filter-item input",function() { 
    
  //   var a = $('li.yv-filter-item input:checked').val();
  //   setTimeout(function() {
  //   $(".itg_ctm_collection .col-6").each(function() {
  //    var b = $(this).attr("data-attr-color");
  //     if(a == b){
  //       $(this).css("display", "block");
  //     }else{
  //       $(this).css("display", "none");
  //     }
  //   });
  //  }, 1000);
  // });

  
});
